import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { sepolia } from "@reown/appkit/networks";
import { WebConfig } from "./WebConfig";

export const appKitNetworks = [sepolia];

export const wagmiAdapter = new WagmiAdapter({
  networks: appKitNetworks,
  projectId: WebConfig.appKit.projectId,
  ssr: false,
});

export const appKit = createAppKit({
  adapters: [wagmiAdapter],
  networks: appKitNetworks,
  defaultNetwork: sepolia,
  projectId: WebConfig.appKit.projectId,
  metadata: WebConfig.appKit.metadata,
  features: {
    analytics: true,
  },
});
